import { useContext } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WorkflowContext } from "../contexts";
import WorkflowAutomationPanelIncomplete from "./WorkflowAutomationPanelIncomplete";
import WorkflowAutomationPanelManual from "./WorkflowAutomationPanelManual";

function WorkflowAutomationPanelSalesforce() {
  const { workflow, automationOptions } = useContext(WorkflowContext);
  const { t } = useTranslation();

  const { url } = useRouteMatch();

  return (
    <>
      <div className="flex flex-col gap-2 select-none">
        {!(workflow.latestAutomation?.status === "PENDING" || workflow.latestAutomation?.status === "RUNNING") &&
          <Link to={url + "/source"} className="flex items-center text-sm w-full font-semibold hover:text-blue hover:underline cursor-pointer">
            {(automationOptions.selectedTotal ?? 0) > 0
              ? <>{t("Process")} <b className="mx-1">{automationOptions.selectedTotal}</b> {t(automationOptions.selectedTotal === 1 ? "selected item" : "selected items")} — {t("Edit selection")}</>
              : <span className="text-gray-400">{t("Select Salesforce records to start an automation")}</span>
            }
          </Link>
        }
        <WorkflowAutomationPanelManual disabled={!automationOptions.selectedTotal} />
      </div>

      <WorkflowAutomationPanelIncomplete />
    </>
  );

}

export default WorkflowAutomationPanelSalesforce;
